import { graphql } from "react-relay";

export const suggestionBodyConflictingMeetingFragments = {
  org: graphql`
    fragment SuggestionBodyConflictingMeeting_org on Org
    @argumentDefinitions(calendarIds: { type: "[String]!", defaultValue: [] }) {
      id
      personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
        __typename
        ... on PersonList {
          list {
            id
            emails
            primaryEmail
            profile {
              givenName
              familyName
              externalImageUrl
            }
            isYou
          }
        }
        ... on GraphEntityError {
          message
        }
      }
    }
  `,
  suggestionPayload: graphql`
    fragment SuggestionBodyConflictingMeeting_suggestionPayload on SuggestionResultPayload {
      ... on SuggestionResultConflictingMeetingPayload {
        targetEvent {
          title
          organizer {
            urnValue
          }
          createdMillis
          startTime {
            type
            dateOrDateTime
            timeZone
            millis
            offsetMinutes
          }
          endTime {
            type
            dateOrDateTime
            timeZone
            millis
            offsetMinutes
          }
        }
        conflictingEvent {
          title
          createdMillis
          organizer {
            urnValue
          }
          startTime {
            type
            dateOrDateTime
            timeZone
            millis
            offsetMinutes
          }
          endTime {
            type
            dateOrDateTime
            timeZone
            millis
            offsetMinutes
          }
        }
      }
    }
  `,
};

export const refetchQuery = graphql`
  query SuggestionBodyConflictingMeetingQuery($orgRelayId: ID!, $calendarIds: [String]!) {
    org: node(id: $orgRelayId) {
      ... on Org {
        ...SuggestionBodyConflictingMeeting_org @arguments(calendarIds: $calendarIds)
      }
    }
  }
`;
